import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemLabsRoute: InvariantJiraRoute = {
	name: 'global-settings-system-labs',
	path: '/jira/settings/system/labs',
};
